module.exports = __webpack_public_path__ + "static/img/sydney-descr.c380383.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sydney/sydney-descr.jpg
// module id = 267
// module chunks = 1